import { createSlice } from "@reduxjs/toolkit";

export const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    payments: [],
    isFetching: false,
    error: false,
  },
  reducers: {
    //GET ALL
    getPaymentStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getPaymentSuccess: (state, action) => {
      state.isFetching = false;
      state.payments = action.payload;
    },
    getPaymentFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    //DELETE
    // deleteEventStart: (state) => {
    //   state.isFetching = true;
    //   state.error = false;
    // },
    // deleteEventSuccess: (state, action) => {
    //   state.isFetching = false;
    //   state.events.splice(
    //     state.events.findIndex((item) => item._id === action.payload),
    //     1
    //   );
    // },
    // deleteEventFailure: (state) => {
    //   state.isFetching = false;
    //   state.error = true;
    // },
    // //UPDATE
    // updateEventStart: (state) => {
    //   state.isFetching = true;
    //   state.error = false;
    // },
    // updateEventSuccess: (state, action) => {
    //   state.isFetching = false;
    //   state.events[
    //     state.events.findIndex((item) => item._id === action.payload.id)
    //   ] = action.payload.event;
    // },
    // updateEventFailure: (state) => {
    //   state.isFetching = false;
    //   state.error = true;
    // },
    // //UPDATE
    // addEventStart: (state) => {
    //   state.isFetching = true;
    //   state.error = false;
    // },
    // addEventSuccess: (state, action) => {
    //   state.isFetching = false;
    //   state.events.push(action.payload);
    // },
    // addEventFailure: (state) => {
    //   state.isFetching = false;
    //   state.error = true;
    // },
  },
});

export const {
  getPaymentStart,
  getPaymentSuccess,
  getPaymentFailure,
} = paymentSlice.actions;

export default paymentSlice.reducer;
